import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { WHATSAPP_URL } from '../siteInfo';

const WhatsAppFloat = () => {
  // Masqué tant qu'on est sur la photo du haut de page : elle a déjà son bouton WhatsApp,
  // et sur mobile le bouton flottant le recouvrait.
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = () => {
    if (window.gtag) window.gtag('event', 'social_click', { network: 'whatsapp', source_page: 'float' });
  };

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`whatsapp-float ${visible ? 'is-visible' : ''}`}
      aria-label="Écrire sur WhatsApp"
      tabIndex={visible ? 0 : -1}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={faWhatsapp} />
    </a>
  );
};

export default WhatsAppFloat;
